var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-image"},[_c('ShopifyAccentuateImage',{staticClass:"page-image__image",attrs:{"src":_vm.page.metafields.image}}),_vm._v(" "),_c('div',{staticClass:"page-image__decorator"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }